export default {
    automations: [],
    selectedAutomation: {},
    selectedAutomations: [],
};
